import { render, staticRenderFns } from "./Notifier.vue?vue&type=template&id=9804dd8e&"
import script from "./Notifier.vue?vue&type=script&lang=js&"
export * from "./Notifier.vue?vue&type=script&lang=js&"
import style0 from "./Notifier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports